import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import "./Index.vue?vue&type=style&index=0&id=0e964122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e964122"]])

export default __exports__